export enum STORAGE_KEY {
  'IS_LOGGED_IN' = 'IS_LOGGED_IN',
  'ACCESS_TOKEN' = 'ACCESS_TOKEN'
}
